import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ChannelData, GridSize, TxPowerSettingsData } from "../transponders-step.model";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { ErrorResponseHandlerService } from "@nms-ng2/app/core/services/error-response-handler/error-response-handler.service";
import { catchError } from "rxjs/operators";

/**
 * Serviço responsável por realizar as requisições referentes aos insumos do passo de Transponders.
 */
@Injectable({
    providedIn: "root"
})
export class TransponderStepCircuitInputService {
    private readonly baseUrl: string;

    constructor(private readonly http: HttpClient, private readonly errorResponseHandlerService: ErrorResponseHandlerService,
        private readonly nmsDialogService: NmsDialogService) {
        this.baseUrl = "/web/topology/circuit/dwdm";
    }

    public getChannels(gidSize: GridSize): Observable<Array<ChannelData>> {
        return this.http
            .get<Array<ChannelData>>(`${this.baseUrl}/options/channels/${gidSize}`)
            .pipe(catchError((error) => {
                this.handleError(error);
                return of([]);
            }));
    }

    public getMultirates(): Observable<Array<string>> {
        return this.http
            .get<string[]>(`${this.baseUrl}/options/multirates`)
            .pipe(catchError((error) => {
                this.handleError(error);
                return of([]);
            }));
    }

    public getTxPowerConfig(): Observable<TxPowerSettingsData> {
        return this.http
            .get<TxPowerSettingsData>(`${this.baseUrl}/settings/tx-power`)
            .pipe(catchError((error) => {
                this.handleError(error);
                return of(null);
            }));
    }

    private handleError(error: HttpErrorResponse): void {
        const { description, details } = this.errorResponseHandlerService.buildErrorDescriptionDetails(error.error);
        this.nmsDialogService.openDialog(
            { description: description + details, acceptLabel: "OK", bindHtml: true },
            { maxWidth: "800px" }
        );
    }
}
